import { defineComponent as s, openBlock as t, createElementBlock as V, mergeProps as v, unref as H, renderSlot as d, createElementVNode as o, createCommentVNode as i } from "vue";
import { useScalarIcon as p } from "../hooks/useScalarIcon.js";
const m = { key: 0 }, u = { key: 1 }, g = { key: 2 }, Z = { key: 3 }, f = { key: 4 }, k = { key: 5 }, M = {
  name: "ScalarIconHashStraight"
}, _ = /* @__PURE__ */ s({
  ...M,
  props: {
    label: {},
    weight: {}
  },
  setup(n) {
    const l = n, { bind: h, weight: e } = p(l);
    return (r, a) => (t(), V("svg", v({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, H(h)), [
      d(r.$slots, "default"),
      H(e) === "bold" ? (t(), V("g", m, a[0] || (a[0] = [
        o("path", { d: "M216,148H172V108h44a12,12,0,0,0,0-24H172V40a12,12,0,0,0-24,0V84H108V40a12,12,0,0,0-24,0V84H40a12,12,0,0,0,0,24H84v40H40a12,12,0,0,0,0,24H84v44a12,12,0,0,0,24,0V172h40v44a12,12,0,0,0,24,0V172h44a12,12,0,0,0,0-24Zm-108,0V108h40v40Z" }, null, -1)
      ]))) : H(e) === "duotone" ? (t(), V("g", u, a[1] || (a[1] = [
        o("path", {
          d: "M160,96v64H96V96Z",
          opacity: "0.2"
        }, null, -1),
        o("path", { d: "M216,152H168V104h48a8,8,0,0,0,0-16H168V40a8,8,0,0,0-16,0V88H104V40a8,8,0,0,0-16,0V88H40a8,8,0,0,0,0,16H88v48H40a8,8,0,0,0,0,16H88v48a8,8,0,0,0,16,0V168h48v48a8,8,0,0,0,16,0V168h48a8,8,0,0,0,0-16Zm-112,0V104h48v48Z" }, null, -1)
      ]))) : H(e) === "fill" ? (t(), V("g", g, a[2] || (a[2] = [
        o("path", { d: "M112,112h32v32H112ZM224,48V208a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32H208A16,16,0,0,1,224,48Zm-64,96V112h32a8,8,0,0,0,0-16H160V64a8,8,0,0,0-16,0V96H112V64a8,8,0,0,0-16,0V96H64a8,8,0,0,0,0,16H96v32H64a8,8,0,0,0,0,16H96v32a8,8,0,0,0,16,0V160h32v32a8,8,0,0,0,16,0V160h32a8,8,0,0,0,0-16Z" }, null, -1)
      ]))) : H(e) === "light" ? (t(), V("g", Z, a[3] || (a[3] = [
        o("path", { d: "M216,154H166V102h50a6,6,0,0,0,0-12H166V40a6,6,0,0,0-12,0V90H102V40a6,6,0,0,0-12,0V90H40a6,6,0,0,0,0,12H90v52H40a6,6,0,0,0,0,12H90v50a6,6,0,0,0,12,0V166h52v50a6,6,0,0,0,12,0V166h50a6,6,0,0,0,0-12Zm-114,0V102h52v52Z" }, null, -1)
      ]))) : H(e) === "regular" ? (t(), V("g", f, a[4] || (a[4] = [
        o("path", { d: "M216,152H168V104h48a8,8,0,0,0,0-16H168V40a8,8,0,0,0-16,0V88H104V40a8,8,0,0,0-16,0V88H40a8,8,0,0,0,0,16H88v48H40a8,8,0,0,0,0,16H88v48a8,8,0,0,0,16,0V168h48v48a8,8,0,0,0,16,0V168h48a8,8,0,0,0,0-16Zm-112,0V104h48v48Z" }, null, -1)
      ]))) : H(e) === "thin" ? (t(), V("g", k, a[5] || (a[5] = [
        o("path", { d: "M216,156H164V100h52a4,4,0,0,0,0-8H164V40a4,4,0,0,0-8,0V92H100V40a4,4,0,0,0-8,0V92H40a4,4,0,0,0,0,8H92v56H40a4,4,0,0,0,0,8H92v52a4,4,0,0,0,8,0V164h56v52a4,4,0,0,0,8,0V164h52a4,4,0,0,0,0-8Zm-116,0V100h56v56Z" }, null, -1)
      ]))) : i("", !0)
    ], 16));
  }
});
export {
  _ as default
};
